import { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';
import { supabase } from '../services/mockData';

const STORAGE_KEY = 'vetklinik_appts_last_viewed';

export function useNewAppointments() {
  const [unreadCount, setUnreadCount] = useState(0);
  const lastViewedRef = useRef<string>(localStorage.getItem(STORAGE_KEY) || new Date(0).toISOString());

  useEffect(() => {
    let mounted = true;

    // Sayfa açıldığında: son görüntülemeden sonra mobilden gelen randevuları say
    const fetchUnread = async () => {
      try {
        const { count, error } = await supabase
          .from('appointments')
          .select('*', { count: 'exact', head: true })
          .eq('source', 'mobile')
          .gt('created_at', lastViewedRef.current);
        if (error) throw error;
        if (mounted && typeof count === 'number') setUnreadCount(count);
      } catch (e) {
        console.error('useNewAppointments fetchUnread:', e);
      }
    };

    fetchUnread();

    // Realtime: yeni randevu gelince bildirim göster + sayacı artır
    // StrictMode çift mount'a karşı unique channel adı kullan
    const channelName = `appointments-new-${Date.now()}-${Math.random()}`;
    const channel = supabase.channel(channelName);

    channel
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'appointments' },
        (payload: any) => {
          const row = payload.new;
          if (row?.source === 'mobile' && mounted) {
            setUnreadCount((c) => c + 1);
            toast.success('🔔 Yeni randevu talebi geldi!', {
              duration: 5000,
              style: { background: '#557236', color: '#fff', fontWeight: 600 },
            });
          }
        }
      )
      .subscribe();

    return () => {
      mounted = false;
      supabase.removeChannel(channel);
    };
  }, []);

  const markAllRead = () => {
    const now = new Date().toISOString();
    localStorage.setItem(STORAGE_KEY, now);
    lastViewedRef.current = now;
    setUnreadCount(0);
  };

  return { unreadCount, markAllRead };
}
